import { useTranslation } from 'react-i18next';

export type SettingsTab = 'connections' | 'team' | 'general';

// A tab of the workspace's settings by its name, both in the tab and in the crumbs of its path.
const SettingsTabCrumb = ({ tab }: { tab: SettingsTab }) => {
    const { t } = useTranslation();

    if (tab === 'connections') return <>{t('connections.title')}</>;
    if (tab === 'team') return <>{t('members.title')}</>;
    return <>{t('nav.settings')}</>;
};

export default SettingsTabCrumb;
